(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alfa-winter-check"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-winter-check]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const boxes = [...root.querySelectorAll('input[type="checkbox"]')];
      const status = root.querySelector('[data-winter-status]');
      const progress = root.querySelector('[data-winter-progress]');
      const reset = root.querySelector('[data-winter-reset]');
      const storageKey = root.dataset.storageKey;
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
        boxes.forEach((box) => { box.checked = saved.includes(box.value); });
      } catch (error) { /* De check blijft bruikbaar wanneer opslag niet beschikbaar is. */ }
      const update = (persist = true) => {
        const checked = boxes.filter((box) => box.checked);
        if (!checked.length) status.textContent = root.dataset.emptyText;
        else if (checked.length === boxes.length) status.textContent = root.dataset.completeText;
        else status.textContent = root.dataset.progressText.replace('[count]', checked.length).replace('[total]', boxes.length);
        progress.style.width = `${boxes.length ? (checked.length / boxes.length) * 100 : 0}%`;
        if (persist) {
          try { localStorage.setItem(storageKey, JSON.stringify(checked.map((box) => box.value))); } catch (error) { /* Geen blokkade voor private browsing. */ }
        }
      };
      boxes.forEach((box) => box.addEventListener('change', () => update()));
      reset?.addEventListener('click', () => {
        boxes.forEach((box) => { box.checked = false; });
        update();
      });
      update(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alfa-winter-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-winter-hero]').forEach((root) => {
      if (root.dataset.lightReady === 'true') return;
      root.dataset.lightReady = 'true';
      const range = root.querySelector('[data-light-range]');
      if (!range) return;
      const update = (value) => {
        const next = Math.max(0, Math.min(100, Number(value)));
        range.value = String(next);
        range.setAttribute('aria-valuetext', next === 0 ? 'Stroomuitval' : next === 100 ? 'Licht aan' : 'Tussen stroomuitval en licht aan');
        root.style.setProperty('--wx-off-opacity', String(1 - next / 100));
      };
      range.addEventListener('input', (event) => update(event.currentTarget.value));
      root.querySelectorAll('[data-light-value]').forEach((button) => {
        button.addEventListener('click', () => update(button.dataset.lightValue));
      });
      update(range.value);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
